import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Form } from '../../../../shared/components';
import Button from '../../../../shared/components/Button';
import Input from '../../../../shared/components/Input';
import { styleUtils } from '../../../../shared/utils';
import { ADD_ONS } from './schemas';
import { AddOnItem } from './components';
import { updateAddOnsSummary as updateSummary } from '../OrderSummary/updateData'
import styles from './styles';
import {ROUTES} from "../../../../shared/constants/navigation";

const { style } = styleUtils;
const COMPONENTS = {
  button: style(Button, styles.button),
  textArea: style(Input)
};
const Container = style(View, styles.container);

class AddOns extends Component {
  componentDidMount() {
    const { formData: { addOns:data } } = this.props;
    if (!data || Object.keys(data).length === 0) return;
    Object.keys(data).forEach(fieldId => {
      updateSummary({name: fieldId, value: data.dhis2SupportPlan}, this.props);
    });
  }

  handleChange = (name, selected) => val => {
    const { handleOnDataChange } = this.props;
    const { target } = val || {};
    let value = val;
    if (target) value = target.value;
    if (selected) value = selected;
    const summary = updateSummary({name, value}, this.props);
    handleOnDataChange(name, value, summary);
  };

  handleOnRemove = name => () => this.handleChange(name)(null);

  render() {
    const {
      t,
      formData: { addOns:data },
      history
    } = this.props;
    return (
      <Container>
        {ADD_ONS(t, data, this.handleChange).map(
          ({ name, params, removeText, ...addOnProps }, index) => {
            const { type } = addOnProps;
            const Component = COMPONENTS[type];
            const showRemove = !!(data && data[name]);
            return (
              <AddOnItem
                key={index}
                showRemove={showRemove}
                t={t}
                removeText={removeText}
                onRemove={this.handleOnRemove(name)}
                {...addOnProps}
              >
                <Component {...params} />
              </AddOnItem>
            );
          }
        )}
        <Form
          showOnlyButtons
          title={t('title')}
          previousButton={{
            label: t('previousButtonLabel'),
            action: () => history.push(ROUTES.SIGN_UP_INSTANCES)
          }}
          nextButton={{
            label: t('nextButtonLabel'),
            action: () => history.push(ROUTES.SIGN_UP_BILLING)
          }}
        />
      </Container>
    );
  }
}

AddOns.propTypes = {
  data: PropTypes.object,
  handleNextStepClick: PropTypes.func,
  handlePreviousStepClick: PropTypes.func,
  handleOnDataChange: PropTypes.func
};

export default AddOns;
